import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { canRoleEditSuggestedOrder } from '../contexts/order.utils';

const useCanEditSuggestedOrder = () => {
  const { team } = useApplicationContext();
  const { sellerCanCreateOrChangeSuggestedOrder } = useFeatureFlag();

  return canRoleEditSuggestedOrder(team?.role, sellerCanCreateOrChangeSuggestedOrder);
};

export default useCanEditSuggestedOrder;
